'use strict';

const index = require('../node/index.cjs');

const config = {
    node: index
};

module.exports = config;
